import { useState } from "react";

interface CoverImageProps {
  uri: string;
}

export function CoverImage({ uri }: CoverImageProps) {
  const [hasError, setHasError] = useState(false);

  if (hasError) return null;

  return (
    <img
      src={uri}
      alt=""
      onError={() => setHasError(true)}
      loading="lazy"
      decoding="async"
      style={{
        width: "100%",
        height: "100%",
        objectFit: "cover",
        display: "block",
      }}
    />
  );
}
